// import Swiper bundle with all modules installed
//import Swiper from 'swiper/bundle';

// import styles bundle
//import 'swiper/css/bundle';

const swiperProjectpage = {

    init () {

        let projectPage = document.getElementById('single-projectpage');
        if(projectPage){

            // init Swiper:
            const swiper = new Swiper('.swiper', {
                // Optional parameters
                direction: 'horizontal',
                loop: true,
            
                // If we need pagination
                pagination: {
                el: '.swiper-pagination',
                type: 'custom',
                renderCustom: function (swiper, current, total) {
                    return '<span>' + current + '</span> <span>|</span><span>' + total + '</span>'; 
                }
                },

                speed: 1000,

                autoplay: {
                    delay: 5000,
                },
            
                // Navigation arrows
                navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                },

            });
        }

       
    }

}

export default swiperProjectpage;
